import React, { useEffect, useState } from 'react';
// import { registerUser } from '../../../_actions/user_actions';
import { registerUser } from '../../../redux/user';
import { setAlert } from '../../../redux/alert';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Card,
  Container,
  FormControl,
  FormHelperText,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
  useMediaQuery,
  Grid,
} from '@mui/material';

import { styled, createTheme } from '@mui/material/styles';
import { orange } from '@mui/material/colors';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { ORGANIZATION_SERVER } from '../../Config';
import axios from 'axios';
axios.defaults.withCredentials = true;

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'white',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  textAlign: 'center',
};

const theme = createTheme({
  main: 'rgba(0, 0, 0, 0.6)',
  orange: orange[500],
});

const CustomGrid = styled(Grid)({
  height: '92px',
});
const CustomGrid2 = styled(Grid)({
  marginTop: '8px',
  height: '92px',
});

const CustomTextField = styled(TextField)({
  '& .MuiInputLabel-root': {
    color: theme.main,
  },
  '& label.Mui-focused': {
    color: theme.orange,
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: theme.orange,
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      borderColor: theme.orange,
    },
  },
  '& .MuiFormHelperText-root': {
    color: 'red',
    fontSize: '0.8rem',
    fontWeight: '600',
  },
});
const CustomFormControl = styled(FormControl)({
  '& .MuiInputLabel-root': {
    color: theme.main,
  },
  '& label.Mui-focused': {
    color: theme.orange,
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: theme.orange,
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      borderColor: theme.orange,
    },
  },
  '& .MuiFormHelperText-root': {
    color: 'red',
    fontSize: '0.8rem',
    fontWeight: '600',
  },
});

const pwRegExp = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>/?]).{8,}[^\s]*$/;
// const phoneRegExp = /[\\s]^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/;
const phoneRegExp = /^\+(?:[0-9] ?){6,14}[0-9]$/;

const validationSchema = Yup.object().shape({
  email: Yup.string().email('Please enter a valid email.').required(`What's your email address?`),
  password: Yup.string()
    .min(8, 'Password must be at least 8 characters.')
    .matches(pwRegExp, 'Password should contain at least one digit, one character and one punctuation.')
    .required('Password is required'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords must match.')
    .required('Confirm Password is required'),
  group: Yup.string().required('Agency is required'),
  name: Yup.string().max(800).required('Name is required'),
  phonenumber: Yup.string().matches(phoneRegExp, {
    message: 'Phone number is not valid',
    excludeEmptyString: true,
  }),
});
const defaultValues = {
  name: '',
  email: '',
  role: 'user',
  password: '',
  confirmPassword: '',
  group: '',
  phonenumber: '',
  status: 'approved',
  salt: '',
};

// const organizationList = [
//   { _id: '66c3d7abb141b8eca49f6be6', name: '경희의료원' },
//   { _id: '66c29492440e87c102439ad2', name: '원광대학교병원' },
//   { _id: '66c3d790b141b8eca49f6be2', name: '전북대학교병원' },
//   { _id: '66c3d7abb141b8eca49f6be3', name: '경희의료원' },
//   { _id: '66c29492440e87c102439ad4', name: '원광대학교병원' },
//   { _id: '66c3d790b141b8eca49f6be5', name: '전북대학교병원' },
// ];

function RegisterPage(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const matches = useMediaQuery('(max-width:768px)');
  const [visiblePW, setVisiblePW] = useState(false);
  const [groupList, setGroupList] = useState([]);
  const [formErrorMessage, setFormErrorMessage] = useState('');
  const [openErrorModal, setOpenErrorModal] = useState(false);

  const handleErrorModalClose = () => {
    setFormErrorMessage('');
    setOpenErrorModal(false);
  };

  const onSubmit = async (data, e) => {
    let formData = {
      name: data.name,
      email: data.email,
      role: data.role,
      password: data.password,
      group: data.group,
      phonenumber: data.phonenumber,
      status: 'approved',
    };
    // async request which may result error
    try {
      dispatch(registerUser(formData)).then((res) => {
        if (res.payload.success) {
          dispatch(setAlert({ alertType: 'registration', alertMsg: 'Registration Successful' }));
          navigate('/manageuser');
        } else if (res.payload.err) {
          setFormErrorMessage(res.payload.msg);
          setOpenErrorModal(true);
        }
      });
    } catch (e) {
      // handle your error
    }
  };

  const {
    handleSubmit,
    register,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: defaultValues,
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_SERVER}${ORGANIZATION_SERVER}/list`).then((res) => {
      // console.log(res.data);
      setGroupList(res.data);
    });
  }, []);

  return (
    <div className="RegisterPage">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Container
          maxWidth="md"
          sx={
            matches ? { paddingTop: '116px', paddingBottom: '100px' } : { paddingTop: '188px', paddingBottom: '100px' }
          }
        >
          <Card elevation={1} sx={{ padding: '16px' }}>
            <Grid container>
              <Grid
                size={{
                  xs: 12,
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 500,
                    textAlign: 'left',
                    float: 'left',
                    color: 'rgba(197,197,197,1.00)',
                  }}
                >
                  Registration
                </Typography>
              </Grid>

              <Grid
                container
                direction="row"
                sx={{
                  justifyContent: 'space-around',
                  alignItems: 'stretch',
                }}
              >
                <CustomGrid size={{ xs: 12, md: 8 }}>
                  <CustomTextField
                    fullWidth
                    variant="standard"
                    label="ID (Email)"
                    autoComplete="email"
                    {...register('email')}
                    value={watch('email') || ''}
                    // error={Boolean(errors.email)}
                    helperText={errors.email?.message}
                    size="small"
                  />
                </CustomGrid>
                <CustomGrid size={{ xs: 12, md: 8 }}>
                  <CustomTextField
                    fullWidth
                    variant="standard"
                    label="Password"
                    type={visiblePW ? 'text' : 'password'}
                    {...register('password')}
                    value={watch('password') || ''}
                    // error={Boolean(errors.password)}
                    helperText={errors.password?.message}
                    size="small"
                    slotProps={{
                      input: {
                        endAdornment: (
                          <IconButton
                            onClick={() => {
                              setVisiblePW(!visiblePW);
                            }}
                          >
                            {visiblePW && <VisibilityOffIcon />}
                            {!visiblePW && <VisibilityIcon />}
                          </IconButton>
                        ),
                      },
                    }}
                  />
                </CustomGrid>
                <CustomGrid size={{ xs: 12, md: 8 }}>
                  <CustomTextField
                    fullWidth
                    variant="standard"
                    label="Confirm Password"
                    type="password"
                    {...register('confirmPassword')}
                    value={watch('confirmPassword') || ''}
                    // error={Boolean(errors.confirmPassword)}
                    helperText={errors.confirmPassword?.message}
                    size="small"
                  />
                </CustomGrid>
                <CustomGrid2 size={{ xs: 12, md: 8 }}>
                  <CustomFormControl variant="outlined" fullWidth>
                    <InputLabel shrink>Organization</InputLabel>
                    <Select
                      label="Organization"
                      name="group"
                      fullWidth
                      {...register('group')}
                      value={watch('group') || ''}
                      // error={Boolean(errors._group)}
                      defaultValue="66c3d7abb141b8eca49f6be6"
                      size="small"
                    >
                      {groupList.length > 0 &&
                        groupList.map((group) => {
                          return (
                            <MenuItem key={group._id} value={group._id}>
                              {`${group.name} ${group.projectName ? `- ${group.projectName}` : ''}`}
                            </MenuItem>
                          );
                        })}
                    </Select>
                    <FormHelperText style={{ margin: '0px', color: 'red' }}>{errors._group?.message}</FormHelperText>
                  </CustomFormControl>
                </CustomGrid2>
                <CustomGrid size={{ xs: 12, md: 8 }}>
                  <CustomTextField
                    fullWidth
                    variant="standard"
                    label="Name"
                    autoComplete="name"
                    {...register('name')}
                    value={watch('name') || ''}
                    slotProps={{
                      htmlInput: { maxLength: 800 },
                    }}
                    // error={Boolean(errors.name)}
                    helperText={errors.name?.message}
                    size="small"
                  />
                </CustomGrid>

                <CustomGrid size={{ xs: 12, md: 8 }}>
                  <CustomTextField
                    fullWidth
                    variant="standard"
                    label="Contact"
                    autoComplete="phonenumber"
                    {...register('phonenumber')}
                    value={watch('phonenumber') || ''}
                    // error={Boolean(errors.phonenumber)}
                    helperText={errors.phonenumber?.message}
                    size="small"
                  />
                </CustomGrid>
                <CustomGrid2 size={{ xs: 12, md: 8 }}>
                  <CustomFormControl variant="outlined" size="small" fullWidth>
                    <InputLabel shrink>Rate</InputLabel>
                    <Select label="Rate" name="role" fullWidth defaultValue={'user'} {...register('role')}>
                      <MenuItem value={'user'}>User</MenuItem>
                      <MenuItem value={'admin'}>Admin</MenuItem>
                      {/* <MenuItem value={'super admin'}>Super Admin</MenuItem> */}
                    </Select>
                  </CustomFormControl>
                </CustomGrid2>
                <CustomGrid2 size={{ xs: 12, md: 8 }}>
                  <Box
                    sx={{
                      textAlign: 'center',
                      marginTop: '20px',
                    }}
                  >
                    <Grid container spacing={1} size={12}>
                      <Grid size="grow"></Grid>
                      <Grid size={4}>
                        <Button
                          variant="outlined"
                          color="error"
                          fullWidth
                          sx={{ textTransform: 'none' }}
                          onClick={() => {
                            navigate(-1);
                          }}
                        >
                          Cancel
                        </Button>
                      </Grid>
                      <Grid size={4}>
                        <Button
                          type="submit"
                          variant="contained"
                          fullWidth
                          sx={{ textTransform: 'none', marginRight: '32px' }}
                        >
                          Register
                        </Button>
                      </Grid>
                      <Grid size="grow"></Grid>
                    </Grid>
                  </Box>
                </CustomGrid2>
              </Grid>
            </Grid>
          </Card>
        </Container>
      </form>
      <Modal
        open={openErrorModal}
        onClose={handleErrorModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <ErrorOutlineRoundedIcon color="warning" style={{ fontSize: 64 }} />
          <Typography id="modal-modal-title" style={{ margin: 16, fontWeight: 600, fontSize: '24px' }}>
            {formErrorMessage}
          </Typography>

          <Button variant="contained" color="error" size="small" onClick={handleErrorModalClose}>
            OK
          </Button>
        </Box>
      </Modal>
    </div>
  );
}

export default RegisterPage;
